import {
  Card,
  CardContent,
} from "../../../../../../shared/components/card/Card";
import { Separator } from "../../../../../../shared/components/separator/Separator";
import KpiLine from "./KpiLine";

const SecondaryKpis = ({ ctr, sessions, bouncesRatio, newUsers, roas }) => {
  return (
    <Card className="w-1/3">
      <CardContent className="flex flex-col px-4 py-2">
        <KpiLine label="CTR" value={ctr} />
        <Separator className="my-1" />
        <KpiLine label="Sesiones" value={sessions} />
        <Separator className="my-1" />
        <KpiLine label="Tasa rebotes" value={bouncesRatio} />
        <Separator className="my-1" />
        <KpiLine label="Nuevos usuarios" value={newUsers} />
        <Separator className="my-1" />
        <KpiLine label="ROAS" value={roas} />
      </CardContent>
    </Card>
  );
};

export default SecondaryKpis;
